<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main history_main" v-infinite-scroll="getData" infinite-scroll-delay="200" infinite-scroll-distance="100">
        <!-- <SubTitleComponent :title="title"></SubTitleComponent> -->
        <div class="box">
          <div class="filter">
            <el-row :gutter="10">
              <el-col :span="3">
                <h4>选择客户</h4>
              </el-col>
              <el-col :span="12">
                <el-select v-model="customerValue" placeholder="请选择" @change="customerChange">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option
                    v-for="item in customerData"
                    :key="item.number"
                    :label="item.number + item.client_name"
                    :value="item.client_name">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="5"><el-button icon="el-icon-right" type="success" @click="toCollect"><span class="btn">收藏的效果图</span></el-button></el-col>
            </el-row>
          </div>
          <!-- <div v-for="(item, index) in renderData" :key="item.effect_id" class="clientBox">
            <div class="name">{{ item.client_name }}</div>
            <div class="spaceBox" v-for="(itemM, indexM) in item.space_data">
              <div class="spaceName">{{ itemM.space_name }}</div>
              <div class="styleBox" v-for="(itemW, indexW) in itemM.style_data">
                <div class="styleName">{{ itemW.style_name }}</div>
                <div class="date">{{ itemW.date }}</div>
                <div class="mediaBox">
                  <div class="item">
                    <img :src="itemW.photo_url" alt="">
                    <div class="mediaName">参考图</div>
                  </div>
                  <div class="item" v-for="(itemS, indexS) in itemW.effect_result" @click="toDetail(index,indexM,indexW,indexS)">
                    <img v-if="itemS.file_type != 1" :src="itemS.file_url" alt="">
                    <video v-if="itemS.file_type == 1" :src="itemS.file_url" :poster="itemW.photo_url"></video>
                    <div class="type">{{ itemS.type == 0 ? '生成效果图' : itemS.type == 1 ? 'AI改图' : '图生视频' }}</div>
                    <div v-if="itemS.file_type == 1" class="play"></div>
                  </div>
                </div>
                <el-divider></el-divider>
              </div>
            </div>
          </div> -->
          <div v-for="(item, index) in renderData" :key="item.effect_id" class="clientBox">
            <div class="sub"><span class="name">{{ item.client_name }}</span> <span class="space_name">{{ item.space_type }}</span> <span class="style_name">{{ item.style_type }}</span></div>
            <div class="date">{{ item.createtime }}</div>
            <div :class="['mediaBox',item.end_photo_url || item.style_photo_url ? 'three' : '']">
              <div class="item">
                <img :src="item.photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="" @click="toDetailImg(index, 0)">
                <div class="mediaName">{{ item.end_photo_url ? '首帧' : '毛坯图' }}</div>
              </div>
              <div class="item" v-if="item.end_photo_url">
                <img :src="item.end_photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="" @click="toDetailImg(index, 2)">
                <div class="mediaName">尾帧</div>
              </div>
              <div class="item" v-if="item.style_photo_url">
                <img :src="item.style_photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="" @click="toDetailImg(index, 2)">
                <div class="mediaName">参考图</div>
              </div>
              <div class="item" @click="toDetail(index)" v-if="item.effect_result.length > 0">
                <img v-if="item.effect_result[0].file_type != 1" :src="item.effect_result[0].file_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="">
                <video v-if="item.effect_result[0].file_type == 1" :src="item.effect_result[0].file_url" :poster="item.photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'"></video>
                <div class="type">{{ item.type == 0 ? '生成效果图' : item.type == 1 ? 'AI改图' : '图生视频' }}</div>
                <div v-if="item.effect_result[0].file_type == 1" class="play"><img src="../../assets/ico_play.png" alt=""></div>
              </div>
            </div>
          </div>
          <div class="btn_top" @click="toTop"></div>
        </div>
        <el-dialog
          v-if="dialogVisible == 'detail_img'"
          custom-class="pop_img"
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true"
          :beforeClose="closeDetail">
          <div class="img" v-if="dialogImg != ''">
            <img :src="dialogImg" alt="">
          </div>
        </el-dialog>
        <el-dialog
          v-if="dialogVisible == 'detail'"
          :visible.sync="dialogVisit"
          width="70%"
          :show-close="true"
          center>
          <!-- <div class="img" v-if="dialogCur[0] != -1">
            <img v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_type == 0" :src="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_url" alt="">
            <video v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_type == 1" :src="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_url" alt="" controls></video>
          </div> -->

          <el-row :gutter="20" class="detail_box row">
            <el-col :span="14">
              <div class="img" v-if="dialogCur != -1">
                <img v-if="renderData[dialogCur].effect_result[0].file_type == 0" :src="renderData[dialogCur].effect_result[0].file_url" alt="" @click="toDetailImg(dialogCur, 1)">
                <video v-if="renderData[dialogCur].effect_result[0].file_type == 1" :src="renderData[dialogCur].effect_result[0].file_url" :poster="renderData[dialogCur].photo_url" alt="" controls></video>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="list" ref="listBox">
                <div class="item title">参数</div>
                <div class="item">
                  <div class="label">创作时间</div>
                  <div class="content">{{ detailData.createtime }}</div>
                </div>
                <div class="item">
                  <div class="label">空间类型</div>
                  <div class="content">{{ detailData.space_type }}</div>
                </div>
                <div class="item">
                  <div class="label">创作风格</div>
                  <div class="content">{{ detailData.style_type }}</div>
                </div>
                <div class="item">
                  <div class="label">AI大模型</div>
                  <div class="content">{{ detailData.model_name }}</div>
                </div>
                <div class="item">
                  <div class="label">风格强度</div>
                  <div class="content">{{ detailData.style_percent }}</div>
                </div>
                <div class="item">
                  <div class="label">描述强度</div>
                  <div class="content">{{ detailData.description_percent }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="tool">
            <!-- <el-col :span="6"><el-button type="primary" icon="el-icon-picture-outline" plain @click="toPath('/effectsave')">生成新的效果图</el-button></el-col>
            <el-col :span="6"><el-button type="primary" icon="el-icon-picture" plain @click="toPath('/effectvideo')">图生视频</el-button></el-col>
            <el-col :span="6"><el-button type="primary" icon="el-icon-first-aid-kit" plain @click="toPath('/effectaiedit')">AI改图</el-button></el-col>
            <el-col :span="6"><el-button type="primary" icon="el-icon-download" plain @click="toDownload">下载</el-button></el-col> -->
            <el-col v-if="detailData.effect_result[0].workblank_id == 0" :span="6"><el-button type="success" icon="el-icon-picture" plain @click="toPath('/effectvideo')">图生视频</el-button></el-col>
            <el-col v-if="detailData.effect_result[0].workblank_id == 0" :span="6"><el-button type="success" icon="el-icon-first-aid-kit" plain @click="toPath('/effectaiedit')">AI改图</el-button></el-col>
            <el-col v-if="detailData.effect_result[0].workblank_id == 0" :span="6"><el-button type="success" :icon="renderData[dialogCur].effect_result[0].favorite == 0 ? 'el-icon-star-off' : 'el-icon-star-on'" @click="toFavorite(dialogCur)" plain>{{ renderData[dialogCur].effect_result[0].favorite == 0 ? '收藏' : '取消收藏' }}</el-button></el-col>
            <el-col :span="detailData.effect_result[0].workblank_id == 0 ? 6 : 24"><el-button type="success" icon="el-icon-download" plain @click="toDownload">下载</el-button></el-col>
          </el-row>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
const imgDemo = require('../../assets/pic_xgt.jpg')
import { apiDownload } from '@/utils/download';

// function processRenderData(renderData, newData) {
//   const _render = JSON.parse(JSON.stringify(renderData));
//   newData.forEach(current => {
//     const {
//       client_name,
//       client_id,
//       effect_id,
//       space_type,
//       style_type,
//       photo_url,
//       createtime,
//       effect_result,
//       type
//     } = current;

//     // 1. 查找或创建客户分组
//     let clientGroup = _render.find(c => c.client_name === client_name);
//     if (!clientGroup) {
//       clientGroup = {
//         client_id,
//         effect_id,
//         client_name,
//         space_data: []
//       };
//       _render.push(clientGroup);
//     }

//     // 2. 查找或创建空间分组
//     let spaceGroup = clientGroup.space_data.find(s => s.space_name === space_type);
//     if (!spaceGroup) {
//       spaceGroup = {
//         space_name: space_type,
//         style_data: []
//       };
//       clientGroup.space_data.push(spaceGroup);
//     }

//     // 3. 添加风格数据到现有空间分组
//     spaceGroup.style_data.push({
//       style_name: style_type,
//       photo_url,
//       date: createtime,
//       effect_result: effect_result.map(e => ({
//         file_url: e.file_url,
//         file_type: e.file_type,
//         effect_id: effect_id,
//         type: type
//       }))
//     });

//     // clientGroup.space_data.push(spaceGroup);

//   }, []);
//   return _render;
// }

let _ajaxType = 0

export default {
  name: 'EffectHistory',
  components: {},
  data() {
    return {
      title: '效果生成历史',
      customerData: [],
      customerValue: '全部',
      searchInput: '',
      renderData: [],
      page: 0,
      pagesize: 10,
      allpage: 0,
      dialogCur: -1,
      dialogVisit: false,
      dialogVisible: '',
      dialogImg: '',
      dialogType: '',
      detailData: {},
      listHeight: 0,
    }
  },
  created() {
    // const _render = processRenderData([], renderData)
    // this.renderData = _render

    // console.log('结果：', _render)
    _ajaxType = 0
    this.page = 0
    this.allpage = 0
    this.getData()
    this.getCustomer()
  },
  methods: {
    getData() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _url = "/api/?mod=effect"
        let _id = ''
        if(this.customerValue != '全部'){
          let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue)
          _id = nowCustomer.client_id
        }
        let _clientData = {
          page: _page + 1,
          pagesize: this.pagesize,
          client_id: _id
        }
        // console.log(this.axios)
        this.axios.post(_url, _clientData).then(json => {
          // 获取
          let _data = json.data.data
          console.log("effectData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            // let _result = processRenderData(this.renderData, _data.result)
            let _result = [...this.renderData, ..._data.result]
            console.log('result', _result)
            this.renderData = _result
          }
          console.log(json.data);
          _ajaxType = 0
        })
      }
    },
    getCustomer() {
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("customerData", _data);
        if (json.data.errcode == 0) {
          // let _client = _data.result[0].client_name
          // if(this.global.type == 'manage' && this.global.clientName != ''){
          //   _client = this.global.clientName
          // }
          // this.customerValue = _client
          this.global.clientId = ''
          this.global.clientName = ''
          this.customerData = _data.result
          // this.getSpace()
        }
        console.log(json.data);
      })
    },
    customerChange(e) {
      console.log('customerChange', e)
      let nowCustomer = {
        client_id: '',
        client_name: ''
      };
      if(e != '全部'){
        nowCustomer = this.customerData.find(c => c.client_name === e)
      }
      this.global.clientId = nowCustomer.client_id
      this.global.clientName = nowCustomer.client_name
      this.page = 0
      this.allpage = 0
      this.renderData = []
      this.getData()
    },
    toDetail(cur) {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _render = this.renderData
      console.log('toDetail',cur)
      console.log('render', _render)
      let _id = _render[cur].effect_id
      // let _id = this.id
      let _url = "/api/?mod=effect&action=detail"
      let _effectData = {
        effect_id: _id
      }
      // console.log(this.axios)
      this.axios.post(_url, _effectData).then(json => {
        _ajaxType = 0
        // 获取
        let _data = json.data.data
        console.log("effectData", _data);
        if (json.data.errcode == 0) {
          // this.customerData = _data
          this.detailData = _data
          this.dialogVisible = 'detail'
          this.dialogCur = [cur]
          this.dialogVisit = true
          // setTimeout(this.getHeight, 200)
          // this.title = _data.client_name
        }
      })
    },
    toDetailImg(cur, type) {
      let _img = this.renderData[cur].photo_url
      if(type == 1){
        this.dialogType = 'img'
        _img = this.renderData[cur].effect_result[0].file_url
      }
      if(type == 2){
        _img = this.renderData[cur].end_photo_url
        if(!_img){
          _img = this.renderData[cur].style_photo_url
        }
      }
      this.dialogImg = _img
      this.dialogVisit = true
      this.dialogVisible = 'detail_img'
    },
    closeDetail(e) {
      console.log('dialogType', this.dialogType)
      if(this.dialogType == 'img'){
        this.dialogType = ''
        this.dialogVisible = 'detail'
        return
      }
      if(this.dialogType != 'img'){
        this.dialogImg = ''
        this.dialogVisit = false
        this.dialogVisible = ''
      }
      e()
    },
    toFavorite(cur) {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=effect_favorite&action=add"
      let _render = [...this.renderData]
      let _type = _render[cur].effect_result[0].favorite
      let _id = _render[cur].effect_result[0].effect_result_id
      let _favoriteData = {
        effect_result_id: _id
      }
      if(_type == 1){
        _url = "/api/?mod=effect_favorite&action=cancel"
        _id = _render[cur].effect_result[0].effect_favorite_id
        _favoriteData = {
          effect_favorite_id: _id
        }
      }
      console.log(_favoriteData)
      this.axios.post(_url, _favoriteData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("favoriteData", _data);
        if (json.data.errcode == 0) {
          let _ftype = 0
          let _content = '取消成功'
          if(_type == 0){
            _ftype = 1
            _content = '收藏成功'
            _render[cur].effect_result[0].effect_favorite_id = _data.effect_favorite_id
          }
          _render[cur].effect_result[0].favorite = _ftype
          this.renderData = _render
          this.$message({
            message: _content,
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    // getHeight() {
    //   let _listbox = this.$refs.listBox
    //   console.log('height', _listbox.offsetHeight)
    //   this.listHeight = _listbox.offsetHeight
    // },
    toDownload(){
      // const link = document.createElement('a')
      let _render = this.renderData
      let _cur = this.dialogCur
      let _href = ''
      let _type = _render[_cur].effect_result[0].file_type
      if(_type == 0){
        let _img = _render[_cur].effect_result[0].file_url
        console.log(_img)
        if (_img.startsWith('https://oss.ylw.s136.ailo.vip')) {
          _href = _img.replace('https://oss.ylw.s136.ailo.vip', '/ai_images');
        }
        if (_img.startsWith('https://aigc.oss.ylwai.cn')) {
          _href = _img.replace('https://aigc.oss.ylwai.cn', '/ai2_images');
        }
      }
      if(_type == 1){
        let _video = _render[_cur].effect_result[0].file_url
        if (_video.startsWith('https://oss.ylw.s136.ailo.vip')) {
          _href = _video.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos');
        }
        if (_video.startsWith('https://aigc.oss.ylwai.cn')) {
          _href = _video.replace('https://aigc.oss.ylwai.cn', '/ai2_videos');
        }
      }
      console.log('href',_href)
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      apiDownload(
        _href
      );
    },
    toPath(path) {
      let _render = this.renderData
      let _cur = this.dialogCur
      let _photo = _render[_cur].effect_result[0].file_url
      // let _style = this.detailData.style_type
      let _space = this.detailData.space_type
      localStorage.setItem('effect_url', _photo)
      localStorage.setItem('effect_space', _space)
      this.$router.push({ path: path })
    },
    toCollect() {
      this.$router.push({ path: '/effectcollect' })
    },
    toTop() {
      let scrollBox = document.querySelector('.main')
      scrollBox.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    }
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}

.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;

  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;

    .filter {
      margin-bottom: 20px;

      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }

      .el-button {
        width: 100%;
      }
    }

    .renderLabel {
      width: 100px;
    }

    .clientBox {
      position: relative;
      vertical-align: bottom;
      margin-top: 20px;
      // padding: 20px;
      // border: 1px solid #DCDFE6;
      // border-radius: 10px;
      .sub {
        position: relative;
        .name {
          font-size: 24px;
          color: rgba(10, 10, 10, 1);
          line-height: 40px;
        }
        .space_name {
          font-size: 18px;
          color: rgba(10, 10, 10, 1);
          line-height: 32px;
        }
        .style_name {
          font-size: 14px;
          color: rgba(10, 10, 10, 1);
          line-height: 24px;
        }
      }
      .date {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 12px;
        color: rgba(10, 10, 10, 0.6);
        line-height: 40px;
      }
      .mediaBox {
        margin-top: 10px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        vertical-align: top;
        .item {
          position: relative;
          font-size: 0;
          box-sizing: border-box;

          img {
            width: 100%;
            aspect-ratio: 4 / 3; /* 宽高比为 1:1 */
            object-fit: cover;
          }

          video {
            position: relative;
            width: 100%;
            // height: calc(100% - 20px);
            aspect-ratio: 4 / 3; /* 宽高比为 1:1 */
            object-fit: cover;
            z-index: 1000;
          }
          .mediaName {
            padding: 10px;
            color: rgba(10, 10, 10, 1);
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
          .play {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(100% - 20px);
            padding: 30%;
            /* background: url(../../assets/ico_play.png) no-repeat;
            background-position: center center;
            background-size: 60%; */
            box-sizing: border-box;
            z-index: 1001;
            img {
              width: 100%;
              height: 100%;
              // aspect-ratio: 1 / 1;
              object-fit: contain;
            }
          }
          .type {
            position: absolute;
            top: 0;
            right: 0;
            padding: 5px 10px;
            background-color: #50b85c;
            border-bottom-left-radius: 5px;
            color: #fff;
            font-size: 14px;
            z-index: 1002;
          }
        }
        &.three {
          grid-template-columns: repeat(3, 1fr);
        }
      }
      &:first-child {
        margin-top: 0;
      }
    }
    .btn_top {
      position: fixed;
      bottom: 50px;
      right: 20px;
      width: 50px;
      height: 50px;
      background: url(../../assets/ico_top.png) no-repeat;
      background-size: 50px 50px;
      background-position: center center;
      background-color: #fff;
      border-radius: 50%;
      z-index: 2000;
    }
  }
  .detail_box {
    display: flex;
    // flex-direction: column;
    .img {
      font-size: 0;
      img {
        max-width: 100%;
        max-height: 50vh;
        border-radius: 10px;
      }
      video {
        max-width: 100%;
        max-height: 50vh;
      }
    }
    .list {
      display: grid;
      grid-template-rows: 50px;       /* 首行高度80px */
      // grid-auto-rows: minmax(60px, 1fr);
      // grid-auto-rows: minmax(calc(100%/7), 1fr);
      gap: 10px;
      height: 100%;
      padding: 20px;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 10px;
      .item {
        height: 100%;
        border-bottom: 1px solid #eee;
        .label {
          display: flex;
          width: 30%;
          height: 100%;
          float: left;
          font-size: 18px;
          align-items: center;
          span {
            display: inline-block;
          }
        }
        .content {
          display: flex;
          width: 70%;
          height: 100%;
          float: right;
          font-size: 18px;
          justify-items: right;
          align-items: center;
        }
        &.title {
          font-size: 24px;
          font-weight: 700;
        }
        &:last-child {
          border: 0;
        }
      }
    }
  }
  .tool {
    margin-top: 40px;
    .el-button {
      width: 100%;
    }
  }
}
.pop_img {
  .img {
    font-size: 0;
    text-align: center;
    img {
      // max-width: 100%;
      // max-height: 70vh;
      // object-fit: contain;
      max-width: 90vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Effect/History.vue